module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_09.e12d3b00.jpg";